import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { NavProvider } from './context/NavContext';

// Admin pages
import AdminAuth from './pages/admin/AdminAuth';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminCandidates from './pages/admin/AdminCandidates';
import AdminQuestions from './pages/admin/AdminQuestions';
import AdminResults from './pages/admin/AdminResults';
import AdminResultDetail from './pages/admin/AdminResultDetail';
import AdminResultInsights from './pages/admin/AdminResultInsights';
import AdminProctoringViolations from './pages/admin/AdminProctoringViolations';
import AdminProctoringViolationDetail from './pages/admin/AdminProctoringViolationDetail';
import AdminGradingSystem from './pages/admin/AdminGradingSystem';
import SuperAdminCandidates from './pages/admin/SuperAdminCandidates';

// Assessment pages
import CandidateLogin from './pages/assessment/CandidateLogin';
import CandidateRegister from './pages/assessment/CandidateRegister';
import CandidateWelcome from './pages/assessment/CandidateWelcome';
import AssessmentPage from './pages/assessment/AssessmentPage';

const AdminRoute = ({ children }) => {
  const { admin, loading } = useAuth();
  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: '#6b6b6b', fontSize: '0.875rem' }}>Loading...</div>;
  return admin ? children : <Navigate to="/admin/login" replace />;
};

const CandidateRoute = ({ children }) => {
  const { candidate, loading } = useAuth();
  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: '#6b6b6b', fontSize: '0.875rem' }}>Loading...</div>;
  return candidate ? children : <Navigate to="/login" replace />;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Assessment Portal */}
      <Route path="/login" element={<CandidateLogin />} />
      <Route path="/register" element={<CandidateRoute><CandidateRegister /></CandidateRoute>} />
      <Route path="/welcome" element={<CandidateRoute><CandidateWelcome /></CandidateRoute>} />
      <Route path="/assessment" element={<CandidateRoute><AssessmentPage /></CandidateRoute>} />

      {/* Admin Portal */}
      <Route path="/admin/login" element={<AdminAuth />} />
      <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
      <Route path="/admin/candidates" element={<AdminRoute><AdminCandidates /></AdminRoute>} />
      <Route path="/admin/super-admin/camera" element={<AdminRoute><SuperAdminCandidates /></AdminRoute>} />
      <Route path="/admin/questions" element={<AdminRoute><AdminQuestions /></AdminRoute>} />
      <Route path="/admin/results" element={<AdminRoute><AdminResults /></AdminRoute>} />
      <Route path="/admin/results/:idOrSlug" element={<AdminRoute><AdminResultDetail /></AdminRoute>} />
      <Route path="/admin/results/:idOrSlug/insights" element={<AdminRoute><AdminResultInsights /></AdminRoute>} />
      <Route path="/admin/proctoring-violations" element={<AdminRoute><AdminProctoringViolations /></AdminRoute>} />
      <Route path="/admin/proctoring-violations/:candidateId" element={<AdminRoute><AdminProctoringViolationDetail /></AdminRoute>} />
      <Route path="/admin/grading-system" element={<AdminRoute><AdminGradingSystem /></AdminRoute>} />

      {/* Default */}
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <NavProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </NavProvider>
    </AuthProvider>
  );
}
